import { useTranslate, useUpdate } from '@refinedev/core';
import { Button, Dropdown } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import type { PublicationDetailOut } from '@/api/generated/schemas';
import { ModStatus } from '@/api/generated/schemas';

interface ModStatusDropdownProps {
  record: PublicationDetailOut;
}

export const ModStatusDropdown = ({ record }: ModStatusDropdownProps) => {
  const t = useTranslate();
  const { mutate: updatePublication } = useUpdate<PublicationDetailOut>();

  const changeModStatus = (status: ModStatus) =>
    updatePublication({
      resource: 'user_catalog.publications',
      id: record.id,
      values: { mod_status: status },
      mutationMode: 'optimistic',
      meta: { method: 'patch' },
    });

  return (
    <Dropdown
      menu={{
        items: Object.values(ModStatus).map((value) => ({
          key: value,
          label: t(`base.mod_status.${value}`),
        })),
        selectable: true,
        selectedKeys: [record.mod_status],
        onClick: ({ key }) => changeModStatus(key as ModStatus),
      }}
    >
      <Button>
        {t('user_catalog.publications.show.actions.change_mod_status')}{' '}
        <DownOutlined />
      </Button>
    </Dropdown>
  );
};
